import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  navigationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',

    '& > button': {
      marginLeft: 16
    }
  },
  loadingIndicator: {
    color: theme.palette.primary.main
  },
  loadingContainer: {
    width: '100%',
    height: 'calc(100vh - 420px)', // 420px for header and footer
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  checkboxRegularContainer: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Roboto-Regular !important'
    },
    '& .MuiFormControlLabel-root': {
      marginBottom: 0
    }
  },
  helpText: {
    paddingBottom: 0,
    marginBottom: 0
  },
  italicText: {
    fontStyle: 'italic'
  },
  bankInfo: {
    fontSize: 16,
    color: '#f44336',
  },
  // Applied to the Dialog's content area so it becomes a bounded flex column.
  // This lets the preview fill the available dialog height and makes its inner
  // document area the scroll surface (the MUI Dialog caps the overall height).
  previewDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  previewModalBody: {
    position: 'relative',
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    // We only need the ProtocolPreview root to fill the available space so its
    // inner document area (not the header) is what scrolls.
    '& #document-preview': {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    },
    // navigation header: first child of the preview root -> keep fixed
    '& #document-preview > div:first-child': {
      flex: '0 0 auto',
    },
    // document content: second child -> take remaining height and scroll
    '& #document-preview > div:last-child': {
      flex: '1 1 auto',
      minHeight: 0,
    },
    // The Fade wrapper around the preview must also pass the height through
    '& > div': {
      height: '100%',
    },
  },
  previewLoadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
    height: '100%',
  },
});

export default makeStyles(styles)